export default __webpack_public_path__ + "static/16-100-51f7047c192475faa55fbd34d5fcb5c5.jpg";